module.exports = __webpack_public_path__ + "static/media/malt-syrup.0939b305.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/malt-syrup.jpg
// module id = 584
// module chunks = 0